






import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import TournamentBasicInformation from '@/modules/tournament/components/TournamentBasicInformation'
import { TournamentAction } from '@/modules/tournament/components/TournamentBasicInformation/TournamentBasicInformation.vue'
import AppButton from '@/modules/shared/components/AppButton'
import {
  MemberJoinedTournamentsEntity,
  TournamentEntity,
  TournamentState
} from '@/api/tournament'
import gsap, { Power2 } from 'gsap'

@Component({
  components: {
    TournamentBasicInformation,
    AppButton
  }
})
export default class FeaturedTournament extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  isHover: boolean = false
  isLogoVisible: boolean = true
  isBannerError: boolean = false

  @Prop({ required: true, type: Object }) readonly tournament!: TournamentEntity
  @Prop({ required: false }) readonly animating!: boolean
  @Prop({ required: true }) readonly index!: string
  @Prop({ default: 25 }) readonly width!: number

  /* Vuex State */
  get joinedTournaments(): MemberJoinedTournamentsEntity[] {
    return this.tournamentModule.joinedTournaments
  }

  /* Computed Properties */
  get bannerSrc() {
    if (!this.tournament.detailBanner || this.isBannerError) {
      return require('@/assets/default/tournament_background.png')
    }
    return this.$vuetify.breakpoint.mobile
      ? this.tournament.detailMobileBanner
      : this.tournament.detailBanner
  }

  get hasJoinedTournament(): boolean {
    return this.joinedTournaments
      .map(tournament => tournament.tournamentId)
      .includes(this.tournament.tournamentId)
  }

  get tournamentAction(): TournamentAction {
    if (
      this.hasJoinedTournament ||
      this.tournament.state !== TournamentState.OpenRegistration
    ) {
      return TournamentAction.ViewTournament
    }
    return TournamentAction.JoinTournament
  }

  get cssRules() {
    return {
      '--width': this.width + '%'
    }
  }

  /* Emitter */
  @Emit('select')
  onTournamentSelected() {
    return this
  }
}
